import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TileContainer, ButtonTile } from '../core/Tiles';

export const HomePage = () => {

    const navigate = useNavigate();

    return (
        <div>

            <TileContainer>
                <ButtonTile className='homeButton' text='Select' onClick={() => { navigate(`/applications`, { replace: false }); }}><h3>Manage Applications</h3><img src='images/settings.png' /></ButtonTile>
                <ButtonTile className='homeButton' text='Select' onClick={() => { navigate(`/categories`, { replace: false }); }}><h3>Manage Categories</h3><img src='images/category.png' /></ButtonTile>               
            </TileContainer>

        </div>
    );
}


